import { render, staticRenderFns } from "./Product-Block.vue?vue&type=template&id=d56d0586&scoped=true"
import script from "./Product-Block.vue?vue&type=script&lang=js"
export * from "./Product-Block.vue?vue&type=script&lang=js"
import style0 from "./Product-Block.vue?vue&type=style&index=0&id=d56d0586&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56d0586",
  null
  
)

export default component.exports